export default __webpack_public_path__ + "locales/az/Notifications.json?hash=b21e34f985a15d2290d2b2dafe5968fe";